export function filterPizzaNouveaute(map){
    map = map.filter((value)=>{
        return value.attributes.Nouveaute;
    });
    return map;
}